import { useEffect, useRef, useState } from 'react';

export default function RenameTextBoxModal({ name, saving, onClose, onSave }) {
  const [draft, setDraft] = useState(name);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const inputRef = useRef(null);
  const busy = saving || submitting;
  useEffect(() => {
    const previousFocus = document.activeElement;
    inputRef.current?.focus();
    inputRef.current?.select();
    return () => previousFocus?.focus();
  }, []);
  const submit = async (event) => {
    event.preventDefault();
    if (busy || !draft.trim()) return;
    setSubmitting(true);
    setError('');
    try {
      if (!await onSave(draft.trim())) setError('Could not rename this text box. Please try again.');
    } catch {
      setError('Could not rename this text box. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };
  return <div className="fixed inset-0 z-[80] flex items-center justify-center bg-slate-900/40 px-4">
    <form role="dialog" aria-modal="true" aria-labelledby="rename-box-heading" onSubmit={submit}
      onKeyDown={(event) => {
        if (event.key === 'Escape' && !busy) { event.stopPropagation(); onClose(); }
        if (event.key === 'Tab') {
          const controls = [...event.currentTarget.querySelectorAll('input:not(:disabled), button:not(:disabled)')];
          const target = event.shiftKey ? controls[controls.length - 1] : controls[0];
          if (document.activeElement === (event.shiftKey ? controls[0] : controls[controls.length - 1])) {
            event.preventDefault(); target?.focus();
          }
        }
      }} className="w-full max-w-md space-y-4 rounded-2xl bg-white p-5 shadow-2xl">
      <h2 id="rename-box-heading" className="text-base font-semibold text-slate-900">Rename text box</h2>
      <label className="block text-sm font-semibold text-slate-700" htmlFor="rename-box-name">Text box name</label>
      <input ref={inputRef} id="rename-box-name" value={draft} disabled={busy} required onChange={(event) => setDraft(event.target.value)} className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm" />
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      <div className="flex justify-end gap-2">
        <button type="button" disabled={busy} onClick={onClose} className="rounded-lg border border-slate-300 px-3 py-2 text-sm disabled:opacity-40">Cancel</button>
        <button type="submit" disabled={busy || !draft.trim()} className="rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white disabled:opacity-40">{busy ? 'Saving…' : 'Save name'}</button>
      </div>
    </form>
  </div>;
}
